import { render, staticRenderFns } from "./TaskDefectAndViolationForm.vue?vue&type=template&id=5d340410&scoped=true"
import script from "./TaskDefectAndViolationForm.vue?vue&type=script&lang=js"
export * from "./TaskDefectAndViolationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d340410",
  null
  
)

export default component.exports